module.exports = __webpack_public_path__ + "img/about-bg2.cc3b3c71.jpg";